import { createReducer } from '@reduxjs/toolkit';

import getPrinterTasks, { setPrinterTasks } from '../../thunks/printerTasks/getPrinterTasks';

const initialState = {
  loading: false,
  error: null,
  data: undefined,
  lastPage: undefined,
  currentPage: 1
};

const getPrinterTasksReducer = createReducer(initialState, {
  [getPrinterTasks.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getPrinterTasks.fulfilled]: (state, { payload: { data, current_page: currentPage, last_page: lastPage } }) => ({
    ...state,
    loading: false,
    data,
    currentPage,
    lastPage
  }),
  [getPrinterTasks.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
  [setPrinterTasks]: (state, { payload }) => {
    const updateData = state?.data?.map((item) => (item?.id === payload?.id ? payload : item));
    return {
      ...state,
      loading: false,
      error: payload,
      data: updateData
    };
  }
});

export default getPrinterTasksReducer;
